var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emd-status-bar",class:_vm.status != '' ? `_color_${_vm.status}` : ''})
}
var staticRenderFns = []

export { render, staticRenderFns }